"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogActions = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DialogActions = _styledComponents.default.div.withConfig({
  displayName: "DialogActions",
  componentId: "sc-1s87bsx-0"
})(function (_ref) {
  var theme = _ref.theme;
  return {
    padding: theme.global.spacing.xlarge,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flex: '0 0 auto',
    '& > :not(:first-child)': {
      marginLeft: theme.global.spacing.medium
    }
  };
});

exports.DialogActions = DialogActions;